module.exports = __webpack_public_path__ + "img/grey_051.724d3055.png";